export const BluePinUrl = 'png/map-pin-blue.png';
export const BlackPinUrl = 'png/map-pin-black.png';
